import { apiGet } from '@/lib/api/client';
import { HRM_PRODUCT_CODE } from '@/lib/api/config';
import type { VerifiedDomainInstance } from '@/types/domain';

export async function verifyOrganizationDomain(
  domainName: string,
): Promise<VerifiedDomainInstance> {
  const normalized = domainName.trim().toLowerCase();
  const envelope = await apiGet<VerifiedDomainInstance>(
    '/domain/verify',
    {
      domain_name: normalized,
      product_code: HRM_PRODUCT_CODE,
    },
    { auth: false },
  );

  if (!envelope.data) {
    throw new Error('Domain verification returned no instance data');
  }

  return envelope.data;
}
